import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import PointRight from '@/components/icons/point-right';
import { LibraryPages, getLibraryUrlPrefix } from '@/utils/url';

export default function LibraryBreadcrumb({
	locale,
	crumbs = [],
	addLinkToLanding = true,
	currentCrumb,
	className = 'py-3',
}) {
	const { t } = useTranslation();

	const breadcrumbs = currentCrumb
		? [
				{ model: { name: t('gynzy-library.library'), slug: '' }, isLink: addLinkToLanding },
				...crumbs.map(c => ({ ...c, isLink: true })),
				...(currentCrumb ? [{ model: { name: currentCrumb, slug: '' }, isLink: false }] : []),
		  ]
		: [];

	return (
		<div className={`container ${className} flex text-xs`}>
			{breadcrumbs.map(item => {
				if (item.isLink) {
					const urlParts = [getLibraryUrlPrefix(locale, t, LibraryPages.CATEGORY), item.slug].filter(p => !!p);
					const path = `/${urlParts.join('/')}`.toLocaleLowerCase();
					return (
						<div key={item.model.name} className="flex items-center">
							<Link to={path} className="text-mariner pr-2 hover:underline">
								{item.model.name}
							</Link>
							<PointRight color="text-heather" size="w-2.5 h-2.5 mr-2" />
						</div>
					);
				}
				return item.model.name;
			})}
		</div>
	);
}
